module.exports = __webpack_public_path__ + "img/leaf-right.f5bca9fb.png";